<template>
    <div>
        <div v-if="error != null">
            <ErrorView :isTranslated=isTranslated :cause="error"/>
        </div>
        <div v-else>
            <div v-if="token == null">
                <ErrorView :isTranslated=isTranslated :cause="'unauthorized'"/>
            </div>
            <template v-else>
                <template v-if="showLoginSelection">
                    <login-selection :isTranslated=isTranslated @continue-login="continueLogin"></login-selection>
                </template>
                <template v-else-if="status">
                    <div v-if="status === ConferenceStatus.LICENSE_EXPIRED">
                        <h2 style="color: darkred">{{ translate("LicenseExpired") }}</h2>
                    </div>
                    <div v-else-if="status === ConferenceStatus.NOT_AVAILABLE">
                        <h2>{{ translate("ConferenceNotAvail") }}</h2>
                    </div>
                    <div v-else-if="status === ConferenceStatus.LOCKED">
                        <h2>{{ translate("CannotConnectToConference") }}</h2>
                        <h3>{{ translate("ConferenceIsLocked") }}</h3>
                    </div>
                    <div v-else-if="status === ConferenceStatus.MEMBERS_ONLY">
                        <h2>{{ translate("CannotConnectToConference") }}</h2>
                        <h3>{{ translate("ConferenceIsPrivate") }}</h3>
                    </div>
                    <div v-else-if="status === ConferenceStatus.ENDED">
                        <h2>{{ translate("ConferenceHasEnded") }}</h2>
                    </div>
                    <div v-else-if="status === ConferenceStatus.CONFLICTED">
                      <h2>{{ translate("TrialStateisNoneAndConflicted" )}}</h2>
                    </div>
                    <div v-else-if="status === ConferenceStatus.STARTED">
                        <div v-if="
                    (
                        type === ConferenceType.TRIAL_SINGLE_HEARING ||
                        type === ConferenceType.TRIAL_PROTECTED_HEARING ||
                        type === ConferenceType.TRIAL_HEARING ||
                        type === ConferenceType.TRIAL_EXTERNAL_HEARING
                    )
                ">
                          <div v-if="trialState === TrialState.NONE">
                            <h2>{{ translate("TrialStateisNone") }}</h2>
                          </div>
                          <div v-else>
                            <h2>{{ translate('WaitingForLogin') }}</h2>
                            <h3>{{ translate('ConferenceHasStarted') }}</h3>
                            <h3>{{translate('RedirectBySupervisor')}}</h3>
                          </div>
                        </div>
                        <div v-else>
                            <h2>{{ translate('ConferenceHasStarted') }}</h2>
                            <h3>{{ translate('Redirect') }}</h3>
                        </div>
                    </div>
                    <div v-else-if="status === ConferenceStatus.SOON_BEGINS">
                        <h2>{{ translate('ConferenceSoonBegins') }}</h2>
                        <h3>{{ translate('RedirectSoon') }}</h3>
                    </div>
                </template>
                <template v-else>
                    <spinner :label="spinnerLabel"></spinner>
                </template>
            </template>
        </div>
    </div>
</template>

<script>
import keycloak from "@/security/keycloak";
import BackendService from "../../service/backendService.js"
import ErrorView from "../../views/ErrorView";
import LoginSelection from "@/components/webrtc-guard/LoginSelection";
import Spinner from "@/components/webrtc-guard/Spinner";
import Router from "@/router";
import {lang} from "@/lang";
import backendService from "@/service/backendService";

const ConferenceStatus = {
    NOT_AVAILABLE: 1,
    ENDED: 2,
    STARTED: 3,
    SOON_BEGINS: 4,
    LICENSE_EXPIRED: 5,
    LOCKED: 6,
    MEMBERS_ONLY: 7,
    CONFLICTED: 8
};

    const ConferenceType = {
        STANDARD: 0,
        POINT_TO_POINT: 1,
        RESERVATION: 2,
        TRIAL_EXTERNAL_HEARING: 3,
        TRIAL_HEARING: 4,
        TRIAL_PROTECTED_HEARING: 5,
        TRIAL_SINGLE_HEARING: 6,
        INTERPRETER_SUBCONFERENCE: 7
    };

    const ConferenceTrialState = {
        NONE: 0,
        IN_CONF: 1,
        IN_HEARING: 2,
        IN_CONF_BREAK: 3,
        IN_HEARING_BREAK: 4
    };

    export default {
        name: "WebrtcGuard",
        components: {
            Spinner,
            LoginSelection,
            ErrorView
        },
        props: {
          isTranslated: Boolean,
        },
        data() {
            return {
                error: null,
                token: null,
                uuid: null,
                ConferenceStatus,
                status: null,
                joinUrl: null,
                remainingSeconds: -1,
                TrialState: ConferenceTrialState,
                trialState: null,
                ConferenceType,
                type: null,
                showLoginSelection: false,
                retrying: false,
                retries: 0,
                isThereNewSystemMessage: false,
                isThereOngoingMaintenance: false,
                systemMessage: {
                author: null,
                content: null,
                createTs: null,
                id: null,
                systemMessageCategory: null,
                title: null
                }
            }
        },
        computed: {
            spinnerLabel() {
                if (this.retrying) {
                    let retries = this.retries;

                    if(this.$props.isTranslated)
                      return `Error, trying again... (${retries})`;
                    else
                      return `Hiba, újrapróbálkozás... (${retries})`;
                } else {
                  return this.translate('Loading');
                }
            }
        },
        methods: {
            getConference(isAuthenticated = true) {
              if(isAuthenticated)
              {
                BackendService.getConference(this.token, keycloak.authenticated ? keycloak.tokenParsed.family_name + ' ' + keycloak.tokenParsed.given_name : null, keycloak.authenticated ? keycloak.tokenParsed.email : 'guest')
                    .then(conf => {
                        this.handleBackendResponse(conf);
                    })
                    .catch(err => {
                        console.log("Failed to get conference:", err);
                        this.retrying = true;
                        this.retries = this.retries + 1;
                        this.checkConference();
                    });
              }
              else
              {
                BackendService.getConference(this.token, "guest",  "guest")
                    .then(conf => {
                      this.handleBackendResponse(conf);
                    })
                    .catch(err => {
                      console.log("Failed to get conference:", err);
                      this.retrying = true;
                      this.retries = this.retries + 1;
                      this.checkConference();
                    });
              }
            },
            handleBackendResponse(conf) {
                this.joinUrl = conf.joinUrl;
                this.remainingSeconds = conf.remainingSeconds;
                switch (conf.status) {
                    case "ENDED":
                        this.status = ConferenceStatus.ENDED;
                        break;
                    case "STARTED":
                        this.status = ConferenceStatus.STARTED;
                        break;
                    case "SOON_BEGINS":
                        this.status = ConferenceStatus.SOON_BEGINS;
                        break;
                    case "NOT_AVAILABLE":
                        this.status = ConferenceStatus.NOT_AVAILABLE;
                        break;
                    case "LICENSE_EXPIRED":
                        this.status = ConferenceStatus.LICENSE_EXPIRED;
                        break;
                    case "LOCKED":
                        this.status = ConferenceStatus.LOCKED;
                        break;
                    case "MEMBERS_ONLY":
                        this.status = ConferenceStatus.MEMBERS_ONLY;
                        break;
                  case "CONFLICTED":
                        this.status = ConferenceStatus.CONFLICTED;
                        break;
                }
                switch (conf.type) {
                    case "STANDARD":
                        this.type = ConferenceType.STANDARD;
                        break;
                    // case "POINT_TO_POINT":
                    //     this.type = ConferenceType.POINT_TO_POINT;
                    //     break;
                    // case "RESERVATION":
                    //     this.type = ConferenceType.RESERVATION;
                    //     break;
                    case "TRIAL_EXTERNAL_HEARING":
                        this.type = ConferenceType.TRIAL_EXTERNAL_HEARING;
                        break;
                    case "TRIAL_HEARING":
                        this.type = ConferenceType.TRIAL_HEARING;
                        break;
                    case "TRIAL_PROTECTED_HEARING":
                        this.type = ConferenceType.TRIAL_PROTECTED_HEARING;
                        break;
                    case "TRIAL_SINGLE_HEARING":
                        this.type = ConferenceType.TRIAL_SINGLE_HEARING;
                        break;
                    case "INTERPRETER_SUBCONFERENCE":
                        this.type = ConferenceType.INTERPRETER_SUBCONFERENCE;
                        break;
                }
                switch (conf.trialState) {
                    case "NONE":
                        this.trialState = ConferenceTrialState.NONE;
                        break;
                    case "IN_CONF":
                        this.trialState = ConferenceTrialState.IN_CONF;
                        break;
                    case "IN_HEARING":
                        this.trialState = ConferenceTrialState.IN_HEARING;
                        break;
                    case "IN_CONF_BREAK":
                        this.trialState = ConferenceTrialState.IN_CONF_BREAK;
                        break;
                    case "IN_HEARING_BREAK":
                        this.trialState = ConferenceTrialState.IN_HEARING_BREAK;
                        break;
                }

                if (this.status === ConferenceStatus.SOON_BEGINS) {
                    this.checkConference();
                } else if (this.status === ConferenceStatus.STARTED) {
                    if (this.joinUrl !== null) {
                        if (
                            this.type === ConferenceType.TRIAL_SINGLE_HEARING ||
                            this.type === ConferenceType.TRIAL_PROTECTED_HEARING ||
                            this.type === ConferenceType.TRIAL_HEARING ||
                            this.type === ConferenceType.TRIAL_EXTERNAL_HEARING
                        ) {
                            if (this.trialState === ConferenceTrialState.IN_CONF) {
                                this.joinConference();
                            } else {
                                this.checkConference();
                            }
                        } else {
                            this.joinConference();
                        }
                    } else {
                        this.checkConference();
                    }
                }
            },
            checkConference() {
                setTimeout(() => {
                    this.getConference();
                }, this.queryTimeout());
            },
            joinConference() {
              setTimeout(() => {
                if (this.uuid) {


                  if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
                    // true for mobile device
                    location.replace(this.joinUrl);

                    BackendService.setCaller(this.uuid, keycloak.authenticated ? keycloak.tokenParsed?.email : "Vendég");

                    let routeData = this.$router.resolve({name: 'TestRoomReview', params: {uuid: this.uuid}});
                    window.open(routeData.href, '_blank');

                  } else {
                    // false for not mobile device
                    window.open(this.joinUrl);

                    BackendService.setCaller(this.uuid, keycloak.authenticated ? keycloak.tokenParsed?.email : "Vendég");

                    Router.push({
                      name: "TestRoomReview",
                      params: {
                        uuid: this.uuid
                      }
                    });
                  }
                } else {
                  location.replace(this.joinUrl);
                }
              }, this.queryTimeout());
            },
            queryTimeout() {
                if (this.remainingSeconds > 0) {
                    return this.remainingSeconds * 1000;
                } else {
                    return 3000;
                }
            },
            continueLogin() {
              this.showLoginSelection = false;
              this.getConference();
            },
            async getIsThereOngoingMaintenance() {
            backendService.getIsThereOngoingMaintenance().then(data => this.isThereOngoingMaintenance = data)
            },
            async getLatestNotSeenSystemMessage(){
              this.systemMessage =  await backendService.getLatestSystemMessage()
              const oneWeekAgo = new Date();
              oneWeekAgo.setDate(oneWeekAgo.getDate()-7)
              if(new Date(this.systemMessage.createTs) < oneWeekAgo){
                this.isThereNewSystemMessage = false
              }else {
              this.isThereNewSystemMessage = window.localStorage.getItem("latestMessageid") == null ||  this.systemMessage.id > parseFloat(window.localStorage.getItem("latestMessageid"));
              }

            },
          isAuthenticated() {
            return keycloak.authenticated;
          },
            translate(property) {
              return this.$props.isTranslated ? lang['en'][property] : lang['hu'][property]
            }
        },
        async mounted() {
          await this.getIsThereOngoingMaintenance();
          await this.getLatestNotSeenSystemMessage();
          if (this.$route.query.error) {
            this.error = this.$route.query.error;
          } else if (this.$route.query.token) {
            this.token = this.$route.query.token;
            this.uuid = this.$route.query.uuid;
            if (this.isThereOngoingMaintenance || this.isThereNewSystemMessage) {
              this.showLoginSelection = true
            } else if (this.isAuthenticated()) {
              this.showLoginSelection = false
              this.continueLogin();
            } else {
              setTimeout(keycloak.login, 0);
            }
          }
        }
    }
</script>

<style scoped>

</style>